<!-- Placeholder rows in the shape of the table that is loading, at the same
     44px row height, so the page does not jump when the real rows arrive. -->
<div class="w-full" role="status" aria-live="polite" aria-label="Loading records">
  <div
    *ngFor="let r of rowList"
    class="grid items-center min-h-row px-5 border-b border-slate_200 last:border-b-0"
    [style.gridTemplateColumns]="'repeat(' + columns + ', minmax(0, 1fr))'">
    <div *ngFor="let c of colList" class="pr-4">
      <ngx-skeleton-loader
        [theme]="{
          height: '12px',
          width: barWidth(c),
          'border-radius': '4px',
          margin: '0'
        }"></ngx-skeleton-loader>
    </div>
  </div>
</div>
